import { useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";
import * as React from "react";
import { Flex, useBreakpointValue, Text, Box } from "@chakra-ui/react";

function VirtualizedList({ items, itemClickHandler, selectedItemsIds }) {
  const parentRef = useRef(null);
  const containerHeight = useBreakpointValue({ base: "100px", xl: "200px" });

  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 35,
    enabled: true
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <Box
      ref={parentRef}
      style={{
        height: containerHeight,
        overflowY: "auto",
        contain: "strict"
      }}
    >
      <Box
        style={{
          height: virtualizer.getTotalSize(),
          width: "100%",
          position: "relative"
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            transform: `translateY(${virtualItems[0]?.start ?? 0}px)`
          }}
        >
          {virtualItems.map((virtualRow) => {
            const dataItem = items[virtualRow.index];

            return (
              <Box
                key={virtualRow.key}
                data-index={virtualRow.index}
                ref={virtualizer.measureElement}
              >
                <Flex
                  width="100%"
                  cursor="pointer"
                  padding={2}
                  alignItems="center"
                  title={dataItem.name}
                  backgroundColor={selectedItemsIds.includes(dataItem.id) ? "esg_gray.100" : null}
                  onClick={() => itemClickHandler(dataItem.id)}
                >
                  <Text
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                  >
                    {dataItem.name}
                  </Text>
                </Flex>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default VirtualizedList;